import { useTranslate } from "@similarweb/i18n-provider";
import type { IconProps } from "@similarweb/icons";
import { DailyRanking, Show, Reshare, Response } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { formatEngagementNumber } from "../utils";

type EngagementItemProps = {
    icon: React.ComponentType<IconProps>;
    text: string;
};

const EngagementItem = ({ icon: Icon, text }: EngagementItemProps) => (
    <Flex
        gap="8px"
        alignItems="center"
    >
        <Icon
            size="xs"
            color={colorsPalettes.carbon[200]}
        />
        <Text
            fontVariant="body2"
            color={colorsPalettes.carbon[500]}
        >
            {text}
        </Text>
    </Flex>
);

type PostEngagementProps = {
    reactions?: number | null;
    comments?: number | null;
    shares?: number | null;
    views?: number | null;
};

export const PostEngagement = ({ reactions, comments, shares, views }: PostEngagementProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            gap="16px"
            flexWrap="wrap"
            alignItems="center"
        >
            {reactions != null ? (
                <EngagementItem
                    icon={DailyRanking}
                    text={translate("activation.alerts.cards.social-post.reactions", {
                        reactions: formatEngagementNumber(reactions),
                    })}
                />
            ) : null}
            {comments != null ? (
                <EngagementItem
                    icon={Response}
                    text={translate("activation.alerts.cards.social-post.comments", {
                        comments: formatEngagementNumber(comments),
                    })}
                />
            ) : null}
            {shares != null ? (
                <EngagementItem
                    icon={Reshare}
                    text={translate("activation.alerts.cards.social-post.shares", {
                        shares: formatEngagementNumber(shares),
                    })}
                />
            ) : null}
            {!!views ? (
                <EngagementItem
                    icon={Show}
                    text={translate("activation.alerts.cards.social-post.views", {
                        views: formatEngagementNumber(views),
                    })}
                />
            ) : null}
        </Flex>
    );
};
